module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "kaoji-title"
  }, [_vm._v(_vm._s(_vm.row.danwei) + _vm._s(_vm.row.kaojitype))]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "基本资料",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('QcxjDetailBase')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "成员信息",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('QcxjDetailCommunity')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "数据导出",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('CenterDownload')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "我的考级",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('ExameApplyListMine')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "新闻公告",
      "is-link": ""
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "社群话题",
      "is-link": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-230a4216","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/QcxjDetail.vue
// module id = 1408
// module chunks = 0